import { Component, Prop, h } from '@stencil/core';
import { injectFont } from '../../utils/utils';
@Component({
  tag: 'rpf-global-nav',
  styleUrl: 'rpf-global-nav.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class RpfGlobalNav {
  @Prop() locale: string;
  @Prop() locales: string;
  @Prop() loggedIn: boolean;
  @Prop() authAnchors: boolean = false;
  @Prop({ reflect: true }) theme: string;
  @Prop() logInPath: string;
  @Prop() logOutPath: string;
  @Prop() signUpPath: string;
  @Prop() logInToken: string;
  @Prop() signUpToken: string;
  @Prop() logInTokenUrl: string;
  @Prop() signUpTokenUrl: string;
  @Prop() hideAccountDropdown: boolean;
  @Prop() hideSignUp: boolean;
  @Prop() hideLogIn: boolean;

  componentWillLoad() {
    injectFont();
  }

  render() {
    return (
      <nav class="rpf-global-nav">
        <rpf-logo theme={this.theme}></rpf-logo>
        <div class="rpf-global-nav__slot">
          <rpf-language-picker locales={this.locales} locale={this.locale} theme={this.theme}></rpf-language-picker>
          <rpf-auth
            locale={this.locale}
            logInToken={this.logInToken}
            signUpToken={this.signUpToken}
            logInTokenUrl={this.logInTokenUrl}
            signUpTokenUrl={this.signUpTokenUrl}
            loggedIn={this.loggedIn}
            authAnchors={this.authAnchors}
            logInPath={this.logInPath}
            logOutPath={this.logOutPath}
            signUpPath={this.signUpPath}
            hideSignUp={this.hideSignUp}
            hideLogIn={this.hideLogIn}
            hideAccountDropdown={this.hideAccountDropdown}
            theme={this.theme}
          ></rpf-auth>
        </div>
      </nav>
    );
  }
}
